import { render } from "./AddShopifyPage.vue?vue&type=template&id=72e81106&ts=true"
import script from "./AddShopifyPage.vue?vue&type=script&lang=ts"
export * from "./AddShopifyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__